// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"8195f546","787":"d163b34f"}[chunkId] + ".chunk.js";
};